import { LOGOUT, LOGIN_SAGA, VERIFY_SAGA } from "../actionTypes";

export const logoutAction = () => {
  return { type: LOGOUT };
};
export const loginAction = (phoneNumber) => {
  return { type: LOGIN_SAGA, payload: phoneNumber };
};
export const verifyAction = (phoneNumber, verifyCode) => {
  return { type: VERIFY_SAGA, payload: { phoneNumber, verifyCode } };
};
